import { ReactElement } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Alert,
  Typography,
} from "@mui/material";
import { Account } from "../../../types";

interface UnarchiveConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  account: Account | null;
}

function UnarchiveConfirmationDialog({
  open,
  onClose,
  onConfirm,
  account,
}: UnarchiveConfirmationDialogProps): ReactElement {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      PaperProps={{
        sx: {
          borderRadius: 1,
          width: "400px",
          maxWidth: "90vw",
        },
      }}
    >
      <DialogTitle sx={{ textAlign: "center" }}>Unarchive Account</DialogTitle>
      <DialogContent>
        <Alert severity="info" sx={{ mb: 2 }}>
          If you unarchive this account, it will appear in your active account list again.
        </Alert>
        <Typography sx={{ textAlign: "center" }}>
          Are you sure you want to unarchive <strong>{account?.accountName}</strong>?
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 3, mb: 1, textAlign: "center" }}>
          The account will be available for use in transactions and transfers.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 2, pb: 2, pt: 1, gap: 1, display: "flex" }}>
        <Button onClick={onClose} variant="outlined" sx={{ flex: 1, py: 1.5 }}>
          Cancel
        </Button>
        <Button onClick={onConfirm} variant="contained" color="primary" sx={{ flex: 1, py: 1.5 }}>
          Unarchive
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default UnarchiveConfirmationDialog;
